// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js'
import './assets/style/fonts.css'
import '@/scss/_main.scss'
import "mobiotics-dynamic-components-vue/dist/mobiotics_dynamic_components_vue.css"
import "mobiotics-dynamic-graph-vue/dist/mobiotics-dynamic-graph-vue.css"

Vue.prototype.$eventHub = new Vue()
Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0)
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js